export function getAppropriateParent(parentArray, loggedinUser){
    let index = -1;
    let returnValue = '';
    for(let i = 0; i < parentArray.length; i++){
        if(parentArray[i] === loggedinUser){
            index = i;
            break;
        }
    }
    if(index > -1){
        returnValue = parentArray[index === 0 ? index : (index - 1)];
    }
    return returnValue;
}